import api from '../api';

// Mocks
import { USE_MENU_MOCKS, getLayoutMock, postMenuMock } from './layoutMockConfig';

/**
 * Get manager layout
 * @param {string} path - The path of the page
 * @param {string | null} [contexte] - The context (optional)
 * @returns {Promise<ApiManagerLayout>} The manager layout
 */
export const getManagerLayout = async (path, contexte = null) => {
  if (USE_MENU_MOCKS) return getLayoutMock();

  const contexteParam = contexte ? `&contexte=${contexte}` : '';
  const response = await api.get(`/layout?path=${path}${contexteParam}`);
  return response.data;
};

/**
 * Post menu configuration (available / favorite flags)
 * @param {ApiMenuPostRequest} data - The full menu tree as partial items
 * @returns {Promise<ApiMenuPostResponse>} The updated menu
 */
export const postMenu = async (data) => {
  if (USE_MENU_MOCKS) return postMenuMock(data);

  const response = await api.post('/menu', data);
  return response.data;
};
